"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var afterpay_1 = require("../../constants/afterpay");
var AfterpayLogo_1 = require("../common/Logo/AfterpayLogo");
var ShopAfterpay = function (_a) {
    var price = _a.price;
    if (!price) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var isAboveAfterpayMinPrice = +price.amount > afterpay_1.MINIMUM_PRICE;
    var pricePerInstallment = {
        amount: (+price.amount / afterpay_1.INSTALLMENT).toFixed(2).toString(),
        currencyCode: 'USD',
    };
    return ((0, preact_1.h)("p", { class: "shop-v2__afterpay" }, !isAboveAfterpayMinPrice ? ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(AfterpayLogo_1.default, null),
        " available for orders above $",
        afterpay_1.MINIMUM_PRICE)) : ((0, preact_1.h)(preact_1.Fragment, null,
        "Only ",
        (0, preact_1.h)("span", { class: "semi-bold" }, (0, hydrogen_react_1.useMoney)(pricePerInstallment).localizedString),
        " with",
        ' ',
        (0, preact_1.h)(AfterpayLogo_1.default, null),
        (0, preact_1.h)("br", null),
        " in ",
        afterpay_1.INSTALLMENT,
        " interest-free payments"))));
};
exports.default = ShopAfterpay;
